



window.HelpCenter = {
  init: function (selectors) {
    var toggler = document.getElementById(selectors.toggler);
    var container = document.getElementById(selectors.container);
    // O application.js também carrega no layout de login, que não tem a central de ajuda.
    if (!toggler || !container) return;

    window.Modal.elements = { toggler: toggler, container: container };
    window.Events.setup(container, toggler);
    window.Crisp.init();
  },

  // O rótulo flutuante do menu lateral recolhido (core/app-menu.js) abre a
  // central por aqui, já que ele é um clone e não o toggler.
  toggle: function () {
    window.Modal.toggle();
  },
};
